// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1glmN","buttons":"RemoveExpirationActionButtons_buttons__3jDFJ"};